import React from 'react';

const encode = (data) => {
  return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&");
}

export class __Contact extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      email: "",
      message: "",
      focusEmail: "",
      focusMessage: "",
      lableEmail: "Email",
      lableMessage: "Message"
    };
  }

  handleSubmit = e => {
    var email = this.state.email;
    var message = this.state.message;
    var at = email.indexOf("@");

    if ( !email && !message ) {
        this.setState({
          lableEmail: "Email",
          focusEmail: "",
          lableMessage: "Message",
          focusMessage: ""
        });
        alert("Please fill-up the form");
    } else if ( email && !message ) {
        this.setState({
          lableEmail: "Email",
          focusEmail: "focus",
          lableMessage: "Oh, it's so sad you have nothing to say..",
          focusMessage: "focus error"
        });
    } else if ( !email && message ) {
        this.setState({
          lableEmail: "Please enter your e-mail",
          focusEmail: "focus error",
          lableMessage: "Message",
          focusMessage: "focus"
        });
    } else if ( at === -1 ) {
      this.setState({
        lableEmail: "Looks wrong here",
        focusEmail: "focus error",
        lableMessage: "Message",
        focusMessage: "focus"
      });
    } else {
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({ "form-name": "contact", ...this.state })
      })
      .then(() => alert("Message sent, thank you."))
      .catch(error => alert(error));
      this.setState({
        email: "",
        message: "",
        lableEmail: "Email",
        lableMessage: "Message",
        focusEmail: "",
        focusMessage: ""
      });
    }

    e.preventDefault();
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  onFocusMsg = () => {
    this.setState({ focusMessage: "focus" });
  }

  onBlurMsg = () => {
    if (!this.state.message) {
      this.setState({ focusMessage: "" });
    }
  }

  onFocusEml = () => {
    this.setState({ focusEmail: "focus" });
  }

  onBlurEml = () => {
    if (!this.state.email) {
      this.setState({ focusEmail: "" });
    }
  }

  render () {
    const {
      email,
      message,
      focusEmail,
      focusMessage,
      lableEmail,
      lableMessage } = this.state;

    return (

      <div className="content fading">
        <h1>Contact</h1>
        <p className="subtitle">Looking forward for every feedback. Wish to implement your creative idea in real new book? Found a bug or mistype? Have a suggestion how to make my website more comfortable? Any other questions?</p>
        <section className="contact-form-section">

          <form onSubmit={this.handleSubmit} name="contact" method="POST" data-netlify="true">

            <p className="hidden">
                <label>Don’t fill this out if you're human: <input name="bot-field" /></label>
            </p>

            <p>
              <label className="email">
                <span className={focusEmail}>{lableEmail}</span>
                <input type="text" name="email" value={email} onChange={this.handleChange} onFocus={this.onFocusEml} onBlur={this.onBlurEml}></input>
              </label>
            </p>

            <div className="hidden">
              <label>Bot field:
                <input name="bot-field"></input>
              </label>
            </div>

            <p>
              <label className="message">
                <span className={focusMessage}>{lableMessage}</span>
                <textarea name="message" value={message} onChange={this.handleChange} onFocus={this.onFocusMsg} onBlur={this.onBlurMsg}></textarea>
              </label>
            </p>

            <div data-netlify-recaptcha="true"></div>

            <div>
              <button className="button" type="submit">
                <div>Send</div>
              </button>
            </div>

          </form>

        </section>
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/__Contact.js